import { PACK_DEFINITIONS } from "game/data/packs/pack-definitions";
import { PackDefinition } from "types/packs/pack-definition";

const PACKS_BY_KEY = new Map(PACK_DEFINITIONS.map((def) => [def.key, def]));

export const getPackDefinition = (key: string): PackDefinition | undefined =>
  PACKS_BY_KEY.get(key);
